import qs from 'qs';
import { newAPI } from '../../../../../../services';

export const createServicesLink = async (userId, establishmentId, clientId, params) => {
  const response = await newAPI.put(`/${userId}/establishment/${establishmentId}/clients/${clientId}/services-link`, qs.stringify(params));
  return response.data;
}